import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { LabelWidthTypes } from "@enums/label-width-types";
import { FormattedMessageTemplate } from "@idw-types/data/message-template";
import { MessageTemplateContentValidationErrors, MessageTemplateVariablesValidationErrors } from "@idw-types/common/validation/message-template/message-template-validation-errors";
import { ThemingConfigurationContainer } from "@containers/common/theming-configuration-container/theming-configuration-container";
import { ThemingFormContainer } from "@containers/common/theming-form-container/theming-form-container";
import { MessageTemplateVariablesFormSection } from "@containers/message-template-details/message-template-details-component/message-template-variables-tab/message-template-variables-form-section/message-template-variables-form-section";
import { MessageTemplatePreviewContainer } from "@containers/message-template-details/message-template-details-component/message-template-preview-container/message-template-preview-container";
import { MessageTemplateContentFormSection } from "@containers/message-template-details/message-template-details-component/message-template-content-tab/message-template-content-form-section/message-template-content-form-section";

type MessageTemplateContentTabProps = {
    state: FormattedMessageTemplate;
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    selectedLanguage: LocaleTypes;
    contentValidationErrors: MessageTemplateContentValidationErrors;
    variablesValidationErrors: MessageTemplateVariablesValidationErrors;
    setSelectedLanguage: (language: LocaleTypes) => void;
    setMessageTemplateState: (state: FormattedMessageTemplate) => void;
};

export const MessageTemplateContentTab = (props: MessageTemplateContentTabProps) => {
    const {
        state,
        labelWidth,
        isDisabled,
        selectedLanguage,
        contentValidationErrors,
        variablesValidationErrors,
        setSelectedLanguage,
        setMessageTemplateState
    } = props;

    const handleUpdateTemplate = (event: React.ChangeEvent<any>) => {
        setMessageTemplateState({
            ...state,
            template: event.target.value
        });
    }

    return (
        <ThemingConfigurationContainer>
            <ThemingFormContainer>
                <MessageTemplateContentFormSection
                    isDisabled={isDisabled}
                    labelWidth={labelWidth}
                    handleUpdateTemplate={handleUpdateTemplate}
                    state={state}
                    validationErrors={contentValidationErrors}
                />
                <MessageTemplateVariablesFormSection
                    isDisabled={isDisabled}
                    labelWidth={labelWidth}
                    selectedLanguage={selectedLanguage}
                    setMessageTemplateState={setMessageTemplateState}
                    setSelectedLanguage={setSelectedLanguage}
                    state={state}
                    validationErrors={variablesValidationErrors}
                />
            </ThemingFormContainer>
            <MessageTemplatePreviewContainer
                state={state}
                selectedLanguage={selectedLanguage}
            />
        </ThemingConfigurationContainer>
    );
};